import { Dispatch } from "@reduxjs/toolkit";
import { IApiError } from "../../models/api";

import { monthlyViewerStatsActions } from "./monthly-viewer-stats-slice";
import { requestOptions, ROOT_URL } from "../utils";
import {
    IDBMonthlyViewerStats,
    MonthlyViewerStats,
} from "../../models/monthly-viewer-stats";
import { errorActions } from "../error/error-slice";

const START_CUTOFF_DATE = process.env.REACT_APP_START_CUTOFF_DATE;

/**
 * Loads stats from the database and updates state
 */
export const loadMonthlyViewerStats = () => async (dispatch: Dispatch) => {
    try {
        dispatch(monthlyViewerStatsActions.loading());

        const response = await fetch(
            `${ROOT_URL}/company/myMonthlyViewerStats`,
            requestOptions()
        );
        const data: IDBMonthlyViewerStats[] & IApiError = await response.json();
        if (!data.statusCode) {
            const stats = (
                START_CUTOFF_DATE
                    ? data.filter(
                          (s) =>
                              new Date(
                                  s._id.year,
                                  s._id.month - 1,
                                  1
                              ).valueOf() >
                              new Date(START_CUTOFF_DATE).valueOf()
                      )
                    : data
            ).map((dbStat) => {
                return new MonthlyViewerStats(
                    dbStat._id.year,
                    dbStat._id.month,
                    dbStat._id.companyId,
                    dbStat._id.age,
                    dbStat._id.ethnicity,
                    dbStat._id.gender,
                    dbStat._id.viewerId,
                    dbStat._id.viewerName,
                    dbStat._id.viewerAvatar,
                    dbStat.playTime
                );
            });
            dispatch(monthlyViewerStatsActions.add(stats));
            dispatch(monthlyViewerStatsActions.updated());
        } else {
            throw new Error((data as IApiError).message);
        }
    } catch (error) {
        console.error(error);
        const message =
            typeof error === "string"
                ? error
                : "Something went wrong when loading monthly viewer stats";
        dispatch(monthlyViewerStatsActions.error(message));
        dispatch(
            errorActions.add([
                {
                    error,
                    message,
                },
            ])
        );
    } finally {
        dispatch(monthlyViewerStatsActions.loaded());
    }
};
